import { render } from "./LastNameInput.vue?vue&type=template&id=06e56d9a&scoped=true"
import script from "./LastNameInput.vue?vue&type=script&lang=js"
export * from "./LastNameInput.vue?vue&type=script&lang=js"

import "./LastNameInput.vue?vue&type=style&index=0&id=06e56d9a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e56d9a"]])

export default __exports__